import Link from 'next/link';
import { BreadcrumbsProps } from 'model/Breadcrumbs';

const Breadcrumbs = ({ fields }: BreadcrumbsProps): JSX.Element => {
  const breadcrumbs = fields.breadcrumbs.value;

  return (
    <div className="container d-flex">
      <div className="breadcrumbs">
        <ol itemScope itemType="https://schema.org/BreadcrumbList" className="d-flex mb-0 ps-0">
          {breadcrumbs.map((item, index) => (
            <li
              key={index}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
              className="text-white body-small pe-1"
              aria-hidden={index === breadcrumbs.length - 1 && true}
            >
              <Link
                href={item.url}
                itemProp="item"
                tabIndex={index === breadcrumbs.length - 1 ? -1 : 0}
              >
                <span itemProp="name">{item.name}</span>
              </Link>
              <meta itemProp="'position'" content={`${index + 1}`} />
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default Breadcrumbs;
